// @ts-ignore
/* eslint-disable */
import { request } from '../../request'

/** No comments are provided by the backend GET /projects/${param0}/publish */
export async function publishControllerStatus(
  // Param type generated by superposition
  params: API.PublishControllerStatusParams,
  options?: { [key: string]: any },
) {
  const { projectId: param0, ...queryParams } = params
  return request<any>(`/projects/${param0}/publish`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  })
}

/** No comments are provided by the backend POST /projects/${param0}/publish */
export async function publishControllerPublishProject(
  // Param type generated by superposition
  params: API.PublishControllerPublishProjectParams,
  body: {
    message?: string
  },
  thumbnail?: File,
  options?: { [key: string]: any },
) {
  const { projectId: param0, ...queryParams } = params
  const formData = new FormData()

  if (thumbnail) {
    formData.append('thumbnail', thumbnail)
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele]

    if (item !== undefined && item !== null) {
      if (typeof item === 'object' && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ''))
        } else {
          formData.append(ele, JSON.stringify(item))
        }
      } else {
        formData.append(ele, item)
      }
    }
  })

  return request<any>(`/projects/${param0}/publish`, {
    method: 'POST',
    params: { ...queryParams },
    data: formData,
    requestType: 'form',
    ...(options || {}),
  })
}

/** No comments are provided by the backend DELETE /projects/${param0}/publish */
export async function publishControllerUnpublish(
  // Param type generated by superposition
  params: API.PublishControllerUnpublishParams,
  options?: { [key: string]: any },
) {
  const { projectId: param0, ...queryParams } = params
  return request<any>(`/projects/${param0}/publish`, {
    method: 'DELETE',
    params: { ...queryParams },
    ...(options || {}),
  })
}
